var _path, _path2, _path3, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDesktopPc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 172,
    height: 97,
    viewBox: "0 0 172 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M135.864 20.6738H171.999V91.3016H135.864V20.6738Z",
    fill: "#353447"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M141.339 0.416992H166.524L171.999 20.6746H135.864L141.339 0.416992Z",
    fill: "#48475D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M139.696 25.0547H169.261V31.0772H139.696V25.0547Z",
    fill: "#0B0B10"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.792 84.7324H141.34V85.2799H140.792V84.7324Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.888 84.7324H142.435V85.2799H141.888V84.7324Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.983 84.7324H143.53V85.2799H142.983V84.7324Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.077 84.7324H144.625V85.2799H144.077V84.7324Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.172 84.7324H145.72V85.2799H145.172V84.7324Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.268 84.7324H146.815V85.2799H146.268V84.7324Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.363 84.7324H147.91V85.2799H147.363V84.7324Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.458 84.7324H149.005V85.2799H148.458V84.7324Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.553 84.7324H150.1V85.2799H149.553V84.7324Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.648 84.7324H151.195V85.2799H150.648V84.7324Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.742 84.7324H152.29V85.2799H151.742V84.7324Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.837 84.7324H153.385V85.2799H152.837V84.7324Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.933 84.7324H154.48V85.2799H153.933V84.7324Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.028 84.7324H155.575V85.2799H155.028V84.7324Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.123 84.7324H156.671V85.2799H156.123V84.7324Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.217 84.7324H157.765V85.2799H157.217V84.7324Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.312 84.7324H158.86V85.2799H158.312V84.7324Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.407 84.7324H159.955V85.2799H159.407V84.7324Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.503 84.7324H161.05V85.2799H160.503V84.7324Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.598 84.7324H162.145V85.2799H161.598V84.7324Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.692 84.7324H163.24V85.2799H162.692V84.7324Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.788 84.7324H164.335V85.2799H163.788V84.7324Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.882 84.7324H165.43V85.2799H164.882V84.7324Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.978 84.7324H166.525V85.2799H165.978V84.7324Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.072 84.7324H167.619V85.2799H167.072V84.7324Z",
    fill: "#18171E"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.792 86.9219H141.34V87.4694H140.792V86.9219Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.888 86.9219H142.435V87.4694H141.888V86.9219Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.983 86.9219H143.53V87.4694H142.983V86.9219Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.077 86.9219H144.625V87.4694H144.077V86.9219Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.172 86.9219H145.72V87.4694H145.172V86.9219Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.268 86.9219H146.815V87.4694H146.268V86.9219Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.363 86.9219H147.91V87.4694H147.363V86.9219Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.458 86.9219H149.005V87.4694H148.458V86.9219Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.553 86.9219H150.1V87.4694H149.553V86.9219Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.648 86.9219H151.195V87.4694H150.648V86.9219Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.742 86.9219H152.29V87.4694H151.742V86.9219Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.837 86.9219H153.385V87.4694H152.837V86.9219Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.933 86.9219H154.48V87.4694H153.933V86.9219Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.028 86.9219H155.575V87.4694H155.028V86.9219Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.123 86.9219H156.671V87.4694H156.123V86.9219Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.217 86.9219H157.765V87.4694H157.217V86.9219Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.312 86.9219H158.86V87.4694H158.312V86.9219Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.407 86.9219H159.955V87.4694H159.407V86.9219Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.503 86.9219H161.05V87.4694H160.503V86.9219Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.598 86.9219H162.145V87.4694H161.598V86.9219Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.692 86.9219H163.24V87.4694H162.692V86.9219Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.788 86.9219H164.335V87.4694H163.788V86.9219Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.882 86.9219H165.43V87.4694H164.882V86.9219Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.978 86.9219H166.525V87.4694H165.978V86.9219Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.072 86.9219H167.619V87.4694H167.072V86.9219Z",
    fill: "#18171E"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.792 85.8271H141.34V86.3747H140.792V85.8271Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.888 85.8271H142.435V86.3747H141.888V85.8271Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.983 85.8271H143.53V86.3747H142.983V85.8271Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.077 85.8271H144.625V86.3747H144.077V85.8271Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.172 85.8271H145.72V86.3747H145.172V85.8271Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.268 85.8271H146.815V86.3747H146.268V85.8271Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.363 85.8271H147.91V86.3747H147.363V85.8271Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.458 85.8271H149.005V86.3747H148.458V85.8271Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.553 85.8271H150.1V86.3747H149.553V85.8271Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.648 85.8271H151.195V86.3747H150.648V85.8271Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.742 85.8271H152.29V86.3747H151.742V85.8271Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.837 85.8271H153.385V86.3747H152.837V85.8271Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.933 85.8271H154.48V86.3747H153.933V85.8271Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.028 85.8271H155.575V86.3747H155.028V85.8271Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.123 85.8271H156.671V86.3747H156.123V85.8271Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.217 85.8271H157.765V86.3747H157.217V85.8271Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.312 85.8271H158.86V86.3747H158.312V85.8271Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.407 85.8271H159.955V86.3747H159.407V85.8271Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.503 85.8271H161.05V86.3747H160.503V85.8271Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.598 85.8271H162.145V86.3747H161.598V85.8271Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.692 85.8271H163.24V86.3747H162.692V85.8271Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.788 85.8271H164.335V86.3747H163.788V85.8271Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.882 85.8271H165.43V86.3747H164.882V85.8271Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.978 85.8271H166.525V86.3747H165.978V85.8271Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.072 85.8271H167.619V86.3747H167.072V85.8271Z",
    fill: "#18171E"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.246 84.1846H140.793V84.7321H140.246V84.1846Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.341 84.1846H141.888V84.7321H141.341V84.1846Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.436 84.1846H142.984V84.7321H142.436V84.1846Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.53 84.1846H144.078V84.7321H143.53V84.1846Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.625 84.1846H145.173V84.7321H144.625V84.1846Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.721 84.1846H146.268V84.7321H145.721V84.1846Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.816 84.1846H147.363V84.7321H146.816V84.1846Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.911 84.1846H148.458V84.7321H147.911V84.1846Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.006 84.1846H149.553V84.7321H149.006V84.1846Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.101 84.1846H150.649V84.7321H150.101V84.1846Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.195 84.1846H151.743V84.7321H151.195V84.1846Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.29 84.1846H152.837V84.7321H152.29V84.1846Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.386 84.1846H153.933V84.7321H153.386V84.1846Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.481 84.1846H155.028V84.7321H154.481V84.1846Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.576 84.1846H156.124V84.7321H155.576V84.1846Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.67 84.1846H157.218V84.7321H156.67V84.1846Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.766 84.1846H158.313V84.7321H157.766V84.1846Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.86 84.1846H159.408V84.7321H158.86V84.1846Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.956 84.1846H160.503V84.7321H159.956V84.1846Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.051 84.1846H161.598V84.7321H161.051V84.1846Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.146 84.1846H162.693V84.7321H162.146V84.1846Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.241 84.1846H163.788V84.7321H163.241V84.1846Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.335 84.1846H164.883V84.7321H164.335V84.1846Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.431 84.1846H165.978V84.7321H165.431V84.1846Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.525 84.1846H167.072V84.7321H166.525V84.1846Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.62 84.1846H168.168V84.7321H167.62V84.1846Z",
    fill: "#18171E"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.246 87.4697H140.793V88.0172H140.246V87.4697Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.341 87.4697H141.888V88.0172H141.341V87.4697Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.436 87.4697H142.984V88.0172H142.436V87.4697Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.53 87.4697H144.078V88.0172H143.53V87.4697Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.625 87.4697H145.173V88.0172H144.625V87.4697Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.721 87.4697H146.268V88.0172H145.721V87.4697Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.816 87.4697H147.363V88.0172H146.816V87.4697Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.911 87.4697H148.458V88.0172H147.911V87.4697Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.006 87.4697H149.553V88.0172H149.006V87.4697Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.101 87.4697H150.649V88.0172H150.101V87.4697Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.195 87.4697H151.743V88.0172H151.195V87.4697Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.29 87.4697H152.837V88.0172H152.29V87.4697Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.386 87.4697H153.933V88.0172H153.386V87.4697Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.481 87.4697H155.028V88.0172H154.481V87.4697Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.576 87.4697H156.124V88.0172H155.576V87.4697Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.67 87.4697H157.218V88.0172H156.67V87.4697Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.766 87.4697H158.313V88.0172H157.766V87.4697Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.86 87.4697H159.408V88.0172H158.86V87.4697Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.956 87.4697H160.503V88.0172H159.956V87.4697Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.051 87.4697H161.598V88.0172H161.051V87.4697Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.146 87.4697H162.693V88.0172H162.146V87.4697Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.241 87.4697H163.788V88.0172H163.241V87.4697Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.335 87.4697H164.883V88.0172H164.335V87.4697Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.431 87.4697H165.978V88.0172H165.431V87.4697Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.525 87.4697H167.072V88.0172H166.525V87.4697Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.62 87.4697H168.168V88.0172H167.62V87.4697Z",
    fill: "#18171E"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.246 85.2793H140.793V85.8268H140.246V85.2793Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.341 85.2793H141.888V85.8268H141.341V85.2793Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.436 85.2793H142.984V85.8268H142.436V85.2793Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.53 85.2793H144.078V85.8268H143.53V85.2793Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.625 85.2793H145.173V85.8268H144.625V85.2793Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.721 85.2793H146.268V85.8268H145.721V85.2793Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.816 85.2793H147.363V85.8268H146.816V85.2793Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.911 85.2793H148.458V85.8268H147.911V85.2793Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.006 85.2793H149.553V85.8268H149.006V85.2793Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.101 85.2793H150.649V85.8268H150.101V85.2793Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.195 85.2793H151.743V85.8268H151.195V85.2793Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.29 85.2793H152.837V85.8268H152.29V85.2793Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.386 85.2793H153.933V85.8268H153.386V85.2793Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.481 85.2793H155.028V85.8268H154.481V85.2793Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.576 85.2793H156.124V85.8268H155.576V85.2793Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.67 85.2793H157.218V85.8268H156.67V85.2793Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.766 85.2793H158.313V85.8268H157.766V85.2793Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.86 85.2793H159.408V85.8268H158.86V85.2793Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.956 85.2793H160.503V85.8268H159.956V85.2793Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.051 85.2793H161.598V85.8268H161.051V85.2793Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.146 85.2793H162.693V85.8268H162.146V85.2793Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.241 85.2793H163.788V85.8268H163.241V85.2793Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.335 85.2793H164.883V85.8268H164.335V85.2793Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.431 85.2793H165.978V85.8268H165.431V85.2793Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.525 85.2793H167.072V85.8268H166.525V85.2793Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.62 85.2793H168.168V85.8268H167.62V85.2793Z",
    fill: "#18171E"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.246 86.374H140.793V86.9215H140.246V86.374Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.341 86.374H141.888V86.9215H141.341V86.374Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.436 86.374H142.984V86.9215H142.436V86.374Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.53 86.374H144.078V86.9215H143.53V86.374Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.625 86.374H145.173V86.9215H144.625V86.374Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.721 86.374H146.268V86.9215H145.721V86.374Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.816 86.374H147.363V86.9215H146.816V86.374Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.911 86.374H148.458V86.9215H147.911V86.374Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.006 86.374H149.553V86.9215H149.006V86.374Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.101 86.374H150.649V86.9215H150.101V86.374Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.195 86.374H151.743V86.9215H151.195V86.374Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.29 86.374H152.837V86.9215H152.29V86.374Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.386 86.374H153.933V86.9215H153.386V86.374Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.481 86.374H155.028V86.9215H154.481V86.374Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.576 86.374H156.124V86.9215H155.576V86.374Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.67 86.374H157.218V86.9215H156.67V86.374Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.766 86.374H158.313V86.9215H157.766V86.374Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.86 86.374H159.408V86.9215H158.86V86.374Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.956 86.374H160.503V86.9215H159.956V86.374Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.051 86.374H161.598V86.9215H161.051V86.374Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.146 86.374H162.693V86.9215H162.146V86.374Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.241 86.374H163.788V86.9215H163.241V86.374Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.335 86.374H164.883V86.9215H164.335V86.374Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.431 86.374H165.978V86.9215H165.431V86.374Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.525 86.374H167.072V86.9215H166.525V86.374Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.62 86.374H168.168V86.9215H167.62V86.374Z",
    fill: "#18171E"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.792 81.4473H141.34V81.9948H140.792V81.4473Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.888 81.4473H142.435V81.9948H141.888V81.4473Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.983 81.4473H143.53V81.9948H142.983V81.4473Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.077 81.4473H144.625V81.9948H144.077V81.4473Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.172 81.4473H145.72V81.9948H145.172V81.4473Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.268 81.4473H146.815V81.9948H146.268V81.4473Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.363 81.4473H147.91V81.9948H147.363V81.4473Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.458 81.4473H149.005V81.9948H148.458V81.4473Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.553 81.4473H150.1V81.9948H149.553V81.4473Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.648 81.4473H151.195V81.9948H150.648V81.4473Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.742 81.4473H152.29V81.9948H151.742V81.4473Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.837 81.4473H153.385V81.9948H152.837V81.4473Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.933 81.4473H154.48V81.9948H153.933V81.4473Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.028 81.4473H155.575V81.9948H155.028V81.4473Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.123 81.4473H156.671V81.9948H156.123V81.4473Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.217 81.4473H157.765V81.9948H157.217V81.4473Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.312 81.4473H158.86V81.9948H158.312V81.4473Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.407 81.4473H159.955V81.9948H159.407V81.4473Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.503 81.4473H161.05V81.9948H160.503V81.4473Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.598 81.4473H162.145V81.9948H161.598V81.4473Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.692 81.4473H163.24V81.9948H162.692V81.4473Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.788 81.4473H164.335V81.9948H163.788V81.4473Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.882 81.4473H165.43V81.9948H164.882V81.4473Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.978 81.4473H166.525V81.9948H165.978V81.4473Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.072 81.4473H167.619V81.9948H167.072V81.4473Z",
    fill: "#18171E"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.792 83.6367H141.34V84.1842H140.792V83.6367Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.888 83.6367H142.435V84.1842H141.888V83.6367Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.983 83.6367H143.53V84.1842H142.983V83.6367Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.077 83.6367H144.625V84.1842H144.077V83.6367Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.172 83.6367H145.72V84.1842H145.172V83.6367Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.268 83.6367H146.815V84.1842H146.268V83.6367Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.363 83.6367H147.91V84.1842H147.363V83.6367Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.458 83.6367H149.005V84.1842H148.458V83.6367Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.553 83.6367H150.1V84.1842H149.553V83.6367Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.648 83.6367H151.195V84.1842H150.648V83.6367Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.742 83.6367H152.29V84.1842H151.742V83.6367Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.837 83.6367H153.385V84.1842H152.837V83.6367Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.933 83.6367H154.48V84.1842H153.933V83.6367Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.028 83.6367H155.575V84.1842H155.028V83.6367Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.123 83.6367H156.671V84.1842H156.123V83.6367Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.217 83.6367H157.765V84.1842H157.217V83.6367Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.312 83.6367H158.86V84.1842H158.312V83.6367Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.407 83.6367H159.955V84.1842H159.407V83.6367Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.503 83.6367H161.05V84.1842H160.503V83.6367Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.598 83.6367H162.145V84.1842H161.598V83.6367Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.692 83.6367H163.24V84.1842H162.692V83.6367Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.788 83.6367H164.335V84.1842H163.788V83.6367Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.882 83.6367H165.43V84.1842H164.882V83.6367Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.978 83.6367H166.525V84.1842H165.978V83.6367Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.072 83.6367H167.619V84.1842H167.072V83.6367Z",
    fill: "#18171E"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.792 82.542H141.34V83.0895H140.792V82.542Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.888 82.542H142.435V83.0895H141.888V82.542Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.983 82.542H143.53V83.0895H142.983V82.542Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.077 82.542H144.625V83.0895H144.077V82.542Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.172 82.542H145.72V83.0895H145.172V82.542Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.268 82.542H146.815V83.0895H146.268V82.542Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.363 82.542H147.91V83.0895H147.363V82.542Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.458 82.542H149.005V83.0895H148.458V82.542Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.553 82.542H150.1V83.0895H149.553V82.542Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.648 82.542H151.195V83.0895H150.648V82.542Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.742 82.542H152.29V83.0895H151.742V82.542Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.837 82.542H153.385V83.0895H152.837V82.542Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.933 82.542H154.48V83.0895H153.933V82.542Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.028 82.542H155.575V83.0895H155.028V82.542Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.123 82.542H156.671V83.0895H156.123V82.542Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.217 82.542H157.765V83.0895H157.217V82.542Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.312 82.542H158.86V83.0895H158.312V82.542Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.407 82.542H159.955V83.0895H159.407V82.542Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.503 82.542H161.05V83.0895H160.503V82.542Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.598 82.542H162.145V83.0895H161.598V82.542Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.692 82.542H163.24V83.0895H162.692V82.542Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.788 82.542H164.335V83.0895H163.788V82.542Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.882 82.542H165.43V83.0895H164.882V82.542Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.978 82.542H166.525V83.0895H165.978V82.542Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.072 82.542H167.619V83.0895H167.072V82.542Z",
    fill: "#18171E"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.246 80.8994H140.793V81.4469H140.246V80.8994Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.341 80.8994H141.888V81.4469H141.341V80.8994Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.436 80.8994H142.984V81.4469H142.436V80.8994Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.53 80.8994H144.078V81.4469H143.53V80.8994Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.625 80.8994H145.173V81.4469H144.625V80.8994Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.721 80.8994H146.268V81.4469H145.721V80.8994Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.816 80.8994H147.363V81.4469H146.816V80.8994Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.911 80.8994H148.458V81.4469H147.911V80.8994Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.006 80.8994H149.553V81.4469H149.006V80.8994Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.101 80.8994H150.649V81.4469H150.101V80.8994Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.195 80.8994H151.743V81.4469H151.195V80.8994Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.29 80.8994H152.837V81.4469H152.29V80.8994Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.386 80.8994H153.933V81.4469H153.386V80.8994Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.481 80.8994H155.028V81.4469H154.481V80.8994Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.576 80.8994H156.124V81.4469H155.576V80.8994Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.67 80.8994H157.218V81.4469H156.67V80.8994Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.766 80.8994H158.313V81.4469H157.766V80.8994Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.86 80.8994H159.408V81.4469H158.86V80.8994Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.956 80.8994H160.503V81.4469H159.956V80.8994Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.051 80.8994H161.598V81.4469H161.051V80.8994Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.146 80.8994H162.693V81.4469H162.146V80.8994Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.241 80.8994H163.788V81.4469H163.241V80.8994Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.335 80.8994H164.883V81.4469H164.335V80.8994Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.431 80.8994H165.978V81.4469H165.431V80.8994Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.525 80.8994H167.072V81.4469H166.525V80.8994Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.62 80.8994H168.168V81.4469H167.62V80.8994Z",
    fill: "#18171E"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.246 84.1846H140.793V84.7321H140.246V84.1846Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.341 84.1846H141.888V84.7321H141.341V84.1846Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.436 84.1846H142.984V84.7321H142.436V84.1846Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.53 84.1846H144.078V84.7321H143.53V84.1846Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.625 84.1846H145.173V84.7321H144.625V84.1846Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.721 84.1846H146.268V84.7321H145.721V84.1846Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.816 84.1846H147.363V84.7321H146.816V84.1846Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.911 84.1846H148.458V84.7321H147.911V84.1846Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.006 84.1846H149.553V84.7321H149.006V84.1846Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.101 84.1846H150.649V84.7321H150.101V84.1846Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.195 84.1846H151.743V84.7321H151.195V84.1846Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.29 84.1846H152.837V84.7321H152.29V84.1846Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.386 84.1846H153.933V84.7321H153.386V84.1846Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.481 84.1846H155.028V84.7321H154.481V84.1846Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.576 84.1846H156.124V84.7321H155.576V84.1846Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.67 84.1846H157.218V84.7321H156.67V84.1846Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.766 84.1846H158.313V84.7321H157.766V84.1846Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.86 84.1846H159.408V84.7321H158.86V84.1846Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.956 84.1846H160.503V84.7321H159.956V84.1846Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.051 84.1846H161.598V84.7321H161.051V84.1846Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.146 84.1846H162.693V84.7321H162.146V84.1846Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.241 84.1846H163.788V84.7321H163.241V84.1846Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.335 84.1846H164.883V84.7321H164.335V84.1846Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.431 84.1846H165.978V84.7321H165.431V84.1846Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.525 84.1846H167.072V84.7321H166.525V84.1846Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.62 84.1846H168.168V84.7321H167.62V84.1846Z",
    fill: "#18171E"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.246 81.9941H140.793V82.5416H140.246V81.9941Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.341 81.9941H141.888V82.5416H141.341V81.9941Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.436 81.9941H142.984V82.5416H142.436V81.9941Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.53 81.9941H144.078V82.5416H143.53V81.9941Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.625 81.9941H145.173V82.5416H144.625V81.9941Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.721 81.9941H146.268V82.5416H145.721V81.9941Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.816 81.9941H147.363V82.5416H146.816V81.9941Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.911 81.9941H148.458V82.5416H147.911V81.9941Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.006 81.9941H149.553V82.5416H149.006V81.9941Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.101 81.9941H150.649V82.5416H150.101V81.9941Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.195 81.9941H151.743V82.5416H151.195V81.9941Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.291 81.9941H152.838V82.5416H152.291V81.9941Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.386 81.9941H153.933V82.5416H153.386V81.9941Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.481 81.9941H155.028V82.5416H154.481V81.9941Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.576 81.9941H156.124V82.5416H155.576V81.9941Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.67 81.9941H157.218V82.5416H156.67V81.9941Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.766 81.9941H158.313V82.5416H157.766V81.9941Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.86 81.9941H159.408V82.5416H158.86V81.9941Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.956 81.9941H160.504V82.5416H159.956V81.9941Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.051 81.9941H161.598V82.5416H161.051V81.9941Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.146 81.9941H162.693V82.5416H162.146V81.9941Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.241 81.9941H163.788V82.5416H163.241V81.9941Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.335 81.9941H164.883V82.5416H164.335V81.9941Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.431 81.9941H165.978V82.5416H165.431V81.9941Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.525 81.9941H167.072V82.5416H166.525V81.9941Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.621 81.9941H168.169V82.5416H167.621V81.9941Z",
    fill: "#18171E"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.246 83.0898H140.793V83.6373H140.246V83.0898Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.341 83.0898H141.888V83.6373H141.341V83.0898Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.436 83.0898H142.984V83.6373H142.436V83.0898Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.53 83.0898H144.078V83.6373H143.53V83.0898Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.625 83.0898H145.173V83.6373H144.625V83.0898Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.721 83.0898H146.268V83.6373H145.721V83.0898Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.816 83.0898H147.363V83.6373H146.816V83.0898Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.911 83.0898H148.458V83.6373H147.911V83.0898Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.006 83.0898H149.553V83.6373H149.006V83.0898Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.101 83.0898H150.649V83.6373H150.101V83.0898Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.195 83.0898H151.743V83.6373H151.195V83.0898Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.29 83.0898H152.837V83.6373H152.29V83.0898Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.386 83.0898H153.933V83.6373H153.386V83.0898Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.481 83.0898H155.028V83.6373H154.481V83.0898Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.576 83.0898H156.124V83.6373H155.576V83.0898Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.67 83.0898H157.218V83.6373H156.67V83.0898Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.766 83.0898H158.313V83.6373H157.766V83.0898Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.86 83.0898H159.408V83.6373H158.86V83.0898Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.956 83.0898H160.503V83.6373H159.956V83.0898Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.051 83.0898H161.598V83.6373H161.051V83.0898Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.146 83.0898H162.693V83.6373H162.146V83.0898Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.241 83.0898H163.788V83.6373H163.241V83.0898Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.335 83.0898H164.883V83.6373H164.335V83.0898Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.431 83.0898H165.978V83.6373H165.431V83.0898Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.525 83.0898H167.072V83.6373H166.525V83.0898Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.62 83.0898H168.168V83.6373H167.62V83.0898Z",
    fill: "#18171E"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M168.167 29.1611C168.167 29.6147 167.799 29.9823 167.346 29.9823C166.892 29.9823 166.524 29.6147 166.524 29.1611C166.524 28.7075 166.892 28.3398 167.346 28.3398C167.799 28.3398 168.167 28.7075 168.167 29.1611Z",
    fill: "#FF375B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M168.167 26.9707C168.167 27.4242 167.799 27.7919 167.346 27.7919C166.892 27.7919 166.524 27.4242 166.524 26.9707C166.524 26.5171 166.892 26.1494 167.346 26.1494C167.799 26.1494 168.167 26.5171 168.167 26.9707Z",
    fill: "#2FD60A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168.988 35.4577H139.97V34.9102H168.988V35.4577Z",
    fill: "#565570"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168.988 40.3844H139.97V39.8369H168.988V40.3844Z",
    fill: "#565570"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168.988 45.3122H139.97V44.7646H168.988V45.3122Z",
    fill: "#565570"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168.988 50.2399H139.97V49.6924H168.988V50.2399Z",
    fill: "#565570"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168.988 55.7145H139.97V55.167H168.988V55.7145Z",
    fill: "#0B0B10"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M163.239 55.4414C163.239 55.8949 159.194 56.2626 154.205 56.2626C149.216 56.2626 145.171 55.8949 145.171 55.4414C145.171 54.9878 149.216 54.6201 154.205 54.6201C159.194 54.6201 163.239 54.9878 163.239 55.4414Z",
    fill: "#0B0B10"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M156.669 66.1177C156.669 67.3273 155.689 68.3078 154.479 68.3078C153.27 68.3078 152.289 67.3273 152.289 66.1177C152.289 64.9082 153.27 63.9277 154.479 63.9277C155.689 63.9277 156.669 64.9082 156.669 66.1177Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.479 64.2008C153.421 64.2008 152.563 65.0588 152.563 66.1171C152.563 67.1754 153.421 68.0333 154.479 68.0333C155.537 68.0333 156.395 67.1754 156.395 66.1171C156.395 65.0588 155.537 64.2008 154.479 64.2008ZM152.015 66.1171C152.015 64.7564 153.118 63.6533 154.479 63.6533C155.84 63.6533 156.943 64.7564 156.943 66.1171C156.943 67.4778 155.84 68.5808 154.479 68.5808C153.118 68.5808 152.015 67.4778 152.015 66.1171Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2583 73.0771V84.1093M66.2583 84.1093L108.485 94.0002M66.2583 84.1093L23.6514 94.0002",
    stroke: "#252337",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1.76386 8.68173C1.86606 4.39041 5.37419 0.964844 9.66673 0.964844H119.162C123.455 0.964844 126.963 4.39041 127.065 8.68173L128.553 71.1643C128.659 75.6026 125.09 79.2576 120.65 79.2576H8.1786C3.73904 79.2576 0.17002 75.6026 0.275726 71.1643L1.76386 8.68173Z",
    fill: "#4D4B65"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.162 5.90554H9.66673C8.05702 5.90554 6.74148 7.19012 6.70315 8.79937L5.21502 71.2819C5.17538 72.9463 6.51376 74.3169 8.1786 74.3169H120.65C122.315 74.3169 123.654 72.9463 123.614 71.282L122.126 8.79937C122.087 7.19012 120.772 5.90554 119.162 5.90554ZM9.66673 0.964844C5.37419 0.964844 1.86606 4.39041 1.76386 8.68173L0.275726 71.1643C0.17002 75.6026 3.73904 79.2576 8.1786 79.2576H120.65C125.09 79.2576 128.659 75.6026 128.553 71.1643L127.065 8.68173C126.963 4.39041 123.455 0.964844 119.162 0.964844H9.66673Z",
    fill: "#302E43"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M13.771 72.6879L15.6236 17.1106C15.6591 16.0454 16.5329 15.2002 17.5988 15.2002H110.702C111.76 15.2002 112.631 16.0343 112.676 17.0919L115.059 72.6879H13.771Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M82.7559 29.4355V21.7705H111.226L111.5 29.4355H82.7559Z",
    fill: "#48465F"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M82.7559 38.7422V31.0771H111.226L111.5 38.7422H82.7559Z",
    fill: "#48465F"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M15.626 18.4852L15.6505 17.1405C15.6701 16.0632 16.549 15.2002 17.6264 15.2002H110.686C111.751 15.2002 112.624 16.0429 112.661 17.1064L112.71 18.4852H15.626Z",
    fill: "black"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9832 16.8424C21.9832 17.1448 21.7381 17.3899 21.4357 17.3899C21.1333 17.3899 20.8882 17.1448 20.8882 16.8424C20.8882 16.54 21.1333 16.2949 21.4357 16.2949C21.7381 16.2949 21.9832 16.54 21.9832 16.8424Z",
    fill: "#8A87B3"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3396 16.8424C20.3396 17.1448 20.0945 17.3899 19.7921 17.3899C19.4898 17.3899 19.2446 17.1448 19.2446 16.8424C19.2446 16.54 19.4898 16.2949 19.7921 16.2949C20.0945 16.2949 20.3396 16.54 20.3396 16.8424Z",
    fill: "#8A87B3"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6975 16.8424C18.6975 17.1448 18.4524 17.3899 18.15 17.3899C17.8477 17.3899 17.6025 17.1448 17.6025 16.8424C17.6025 16.54 17.8477 16.2949 18.15 16.2949C18.4524 16.2949 18.6975 16.54 18.6975 16.8424Z",
    fill: "#8A87B3"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8407 22.7085C20.8674 22.1829 21.3013 21.7705 21.8275 21.7705H80.1421C80.6813 21.7705 81.1209 22.2028 81.1301 22.7419L81.6441 53.0682C81.6534 53.6205 81.2084 54.0731 80.6561 54.0731H20.2855C19.7201 54.0731 19.27 53.5995 19.2987 53.0348L20.8407 22.7085Z",
    fill: "#777595"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopPc);
export default __webpack_public_path__ + "static/media/DesktopPC.b83d4d33b165e235c5b0e38c8abe8512.svg";
export { ForwardRef as ReactComponent };